import styled from "styled-components";
import Color from "../../constants/Color";
import { SpacingType } from "../../constants/Spacing";
import Breakpoint from "../../constants/Breakpoint";

interface Props {
    margin?: SpacingType;
    marginTop?: SpacingType;
    marginBottom?: SpacingType;
    marginLeft?: SpacingType;
    marginRight?: SpacingType;
}

const Paragraph = styled.p<Props>`
    padding: 0px;
    font-weight: 400;
    font-size: 18px;
    line-height: 21px;
    @media (${Breakpoint.PHONE_AND_DOWN}) {
        font-size: 16px;
        line-height: 19px;
    }
    
    color: ${Color.TEXT_DARK_2};

    margin: ${({ margin }: Props) => margin || 0};
    margin-top: ${({ marginTop }: Props) => marginTop || 0};
    margin-bottom: ${({ marginBottom }: Props) => marginBottom || 0};
    margin-left: ${({ marginLeft }: Props) => marginLeft || 0};
    margin-right: ${({ marginRight }: Props) => marginRight || 0};
`;

export default Paragraph;
